var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94531 4.5H20.0545C20.1998 4.5 20.342 4.54221 20.4637 4.62149C20.5855 4.70077 20.6816 4.81371 20.7404 4.94658C20.7992 5.07946 20.8181 5.22655 20.7948 5.36998C20.7716 5.51341 20.7072 5.64699 20.6094 5.7545L14.4449 12.5354C14.3194 12.6735 14.2499 12.8534 14.2499 13.04V18.3486C14.2499 18.4721 14.2194 18.5936 14.1612 18.7025C14.1029 18.8114 14.0187 18.9042 13.9159 18.9726L10.9159 20.9727C10.803 21.048 10.6717 21.0912 10.5361 21.0977C10.4005 21.1043 10.2657 21.0739 10.146 21.0099C10.0263 20.9458 9.92626 20.8505 9.8565 20.734C9.78674 20.6176 9.7499 20.4844 9.7499 20.3486V13.04C9.7499 12.8534 9.68036 12.6735 9.55485 12.5355L3.39036 5.7545C3.29262 5.64699 3.22822 5.51341 3.20497 5.36998C3.18173 5.22655 3.20065 5.07946 3.25943 4.94658C3.31821 4.81371 3.41432 4.70077 3.53608 4.62149C3.65785 4.54221 3.80001 4.5 3.94531 4.5Z",
    stroke: "#5E718D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.069fea6e39464174e5653c8932c3ba4d.svg";
export { ForwardRef as ReactComponent };